<template>
    <div id="my-strictly-unique-vue-upload-multiple-image" >
        <vue-upload-multiple-image
            @upload-success="uploadImageSuccess"
            @before-remove="beforeRemove"
            @edit-image="editImage"
            :data-images="images"
            dragText="Drag or select images here"
            browseText=""
            :isEditable="isEditable"></vue-upload-multiple-image>

    </div>
</template>

<script>
    import VueUploadMultipleImage from './common/VueUploadMultipleImage';
    export default {
        props: ['images', 'isEditable'],
        components: {
            VueUploadMultipleImage,
        },
        methods: {
            uploadImageSuccess(formData, index, fileList) {
                this.$emit('update', fileList)
            },

            beforeRemove(index, remove_fn, fileList) {
                this.$emit('update', fileList);
                remove_fn();
            },

            editImage(formData, index, fileList) {
                this.$emit('update', fileList)
            },
        }

    }
</script>
<style scoped>
    #my-strictly-unique-vue-upload-multiple-image{
        display: flex;
        justify-content: center;
    }
</style>
